var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"results__lists"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.colorName)}}),_c('a',{attrs:{"href":'https://' + _vm.website,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.website))])])
}
var staticRenderFns = []

export { render, staticRenderFns }